/**
 * i18n Configuration for Branka
 * Supports: English (en), Traditional Chinese (zh-TW)
 *
 * During development, language is hardcoded to English.
 * To enable language detection/switching later:
 * 1. Install i18next-browser-languagedetector
 * 2. Add LanguageDetector to the .use() chain
 * 3. Configure detection order (localStorage, navigator, etc.)
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import zhTW from './locales/zh-TW.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-TW': { translation: zhTW },
    },
    lng: 'en', // Hardcoded to English during development
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-TW'],

    interpolation: {
      escapeValue: false, // React already handles escaping
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
